import React, { createContext, useContext, useState, useEffect } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

const BrandContext = createContext({
  logoUrl: null,
  primaryHex: "#D4AF37",
  brandLoading: true,
  refreshBrand: () => {}
});

export const useBrand = () => useContext(BrandContext);

export const BrandProvider = ({ children }) => {
  const [brand, setBrand] = useState({
    logoUrl: null,
    primaryHex: "#D4AF37"
  });
  const [brandLoading, setBrandLoading] = useState(true);

  const fetchBrand = async () => {
    try {
      const res = await fetch(`${BACKEND_URL}/api/brand`);
      if (res.ok) {
        const data = await res.json();
        setBrand(data);
      }
    } catch (error) {
      console.error("Failed to fetch brand:", error);
    } finally {
      setBrandLoading(false);
    }
  };

  useEffect(() => {
    fetchBrand();
  }, []);

  const refreshBrand = () => {
    fetchBrand();
  };

  return (
    <BrandContext.Provider value={{ ...brand, brandLoading, refreshBrand }}>
      {children}
    </BrandContext.Provider>
  );
};
